export const isSearchValid = (phrase) => {
    return !RegExp(/((''|"")|('"|"'))/g).test(phrase);
};
